import { render, staticRenderFns } from "./paramsOnchain.vue?vue&type=template&id=1c86d4f3&scoped=true&"
import script from "./paramsOnchain.vue?vue&type=script&lang=js&"
export * from "./paramsOnchain.vue?vue&type=script&lang=js&"
import style0 from "./paramsOnchain.vue?vue&type=style&index=0&id=1c86d4f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86d4f3",
  null
  
)

export default component.exports